import { Autocomplete, TextField } from '@mui/material';
import { FC, useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { IDropdownResponse } from '../../models';
import { getAdminLookupStates, getCommonLookupStates } from '../../fetch/lookups';

interface IStatesDropdownProps {
  value: string | number;
  handleChange: (val: string) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  isRequired?: boolean;
  message?: string;
  hasError?: boolean;
  isAdminPortal?: boolean;
}

export const StatesDropdown: FC<IStatesDropdownProps> = ({
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  message,
  hasError,
  isAdminPortal = false
}) => {
  const { isLoading, data: statesdata } = useQuery<IDropdownResponse[], Error>(
    ['states-data'],
    () => (isAdminPortal ? getAdminLookupStates() : getCommonLookupStates()),
    {
      onSuccess: d => setOptions?.(d)
    }
  );
  const states = useMemo(() => statesdata ?? [], [statesdata]);

  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(states?.find(s => s.shorthand === value)?.description ?? '');
  }, [value, states]);

  return (
    <Autocomplete
      freeSolo
      disabled={isDisabled || isLoading}
      id={`stateId`}
      value={displayValue}
      // @ts-ignore
      onChange={(event, newValue: string) => {
        const state = states?.find(s => s.description === newValue);
        handleChange((state?.shorthand as string) ?? '');
      }}
      autoComplete
      autoSelect
      autoHighlight
      options={states?.map(s => s.description)}
      renderInput={params => (
        <TextField
          {...params}
          key={params.id}
          size="small"
          label={isLoading ? 'Loading...' : 'State'}
          required={isRequired}
          disabled={isDisabled}
          autoComplete="off"
          variant="outlined"
          InputProps={{
            ...params.InputProps
          }}
        />
      )}
    />
  );
};
